import { MetricBoundariesTypeId as MetricBoundariesTypeId$1, isMetricBoundaries as isMetricBoundaries$1, fromChunk as fromChunk$1, linear as linear$1, exponential as exponential$1 } from '../../internal/metric/boundaries.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricBoundariesTypeId = MetricBoundariesTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricBoundaries = isMetricBoundaries$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const fromChunk = fromChunk$1;

/**
 * A helper method to create histogram bucket boundaries for a histogram
 * with linear increasing values.
 *
 * @since 2.0.0
 * @category constructors
 */
const linear = linear$1;

/**
 * A helper method to create histogram bucket boundaries for a histogram
 * with exponentially increasing values.
 *
 * @since 2.0.0
 * @category constructors
 */
const exponential = exponential$1;

export { MetricBoundariesTypeId, exponential, fromChunk, isMetricBoundaries, linear };
